<div echarts [options]="chartOption" class="chart-container"></div>
